var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0755 9.18864C12.0833 9.19642 14.4895 11.6031 14.4895 11.6031C15.19 12.6726 13.6394 14.0348 12.8044 14.471C11.8689 14.9599 10.5133 14.4282 9.6166 14.0293C8.01379 13.3171 6.62321 12.247 5.3893 11.0131C4.00816 9.64254 2.7687 8.17807 1.9709 6.38304C1.57201 5.4858 1.04033 4.13078 1.52867 3.1952C1.96479 2.35963 3.3276 0.809605 4.39706 1.51017L6.81099 3.92411C7.71767 4.83079 5.85986 5.93748 5.85931 6.71638C5.85875 7.23861 6.15431 7.70973 6.42154 8.13696C6.73877 8.64308 7.15211 9.08531 7.63712 9.43309C8.09657 9.7631 8.6988 10.1414 9.28381 10.1409C10.0622 10.1403 11.1688 8.28196 12.0755 9.18864Z",
    fill: "#7C7C7C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone3);
export default __webpack_public_path__ + "static/media/phone-3.3ce68903.svg";
export { ForwardRef as ReactComponent };